import type { definitions } from '@erebus/api-types';
import { AbstractResponse } from 'src/models/api';

export enum NotificationAction {
  LOAD_CASE = 'loadCase',
  LOAD_NOTIFICATIONS = 'loadNotifications',
}

/**
 * API Response Types (generated from Swagger)
 * These types come directly from the backend OpenAPI spec
 */
export type VapidResponse = definitions['pkg_devices.VapidKeyResponse'];

export interface NotificationPayload {
  caseID: number | undefined;
}

export interface INotificationData {
  actions: NotificationAction[];
  payload: NotificationPayload;
  notificationType: NotificationType;
}

export enum NotificationType {
  SOAP = 'soap',
  MESSAGE = 'message',
  CLINIC = 'clinic',
  ATTACHMENT = 'attachment',
  CASE_ASSIGNMENT = 'caseAssignment',
  VITALS = 'vitals',
  AUDIO_NOTE = 'audioNote',
}

interface INotificationBase {
  ID: string;
  userID: number;
  caseID: number | null;
  type: NotificationType;
  message: string;
  read: boolean;
  createdBy: number;
  deletedBy: number | null;
}

export interface INotificationResponse extends INotificationBase {
  createdAt: string;
  readAt: string | null;
  deletedAt: string | null;
}

export interface INotification extends INotificationBase {
  createdAt: Date;
  readAt: Date | null;
  deletedAt: Date | null;
}

export class ErebusNotification extends AbstractResponse implements INotification {
  ID: string;
  userID: number;
  caseID: number | null;
  type: NotificationType;
  message: string;
  read: boolean;
  createdBy: number;
  deletedBy: number | null;
  createdAt: Date;
  readAt: Date | null;
  deletedAt: Date | null;

  requiredFields: string[] = ['ID', 'userID', 'type', 'message', 'read', 'createdBy', 'createdAt'];
  stringFields: string[] = ['ID', 'message'];
  numberFields: string[] = ['userID', 'caseID', 'createdBy', 'deletedBy'];
  booleanFields: string[] = ['read'];
  dateFields: string[] = ['createdAt', 'readAt', 'deletedAt'];

  constructor(data: INotificationResponse) {
    super(data);
    this.ID = data.ID;
    this.userID = data.userID;
    this.caseID = data.caseID;
    this.type = data.type;
    this.message = data.message;
    this.read = data.read;
    this.createdBy = data.createdBy;
    this.deletedBy = data.deletedBy;
    this.createdAt = new Date(data.createdAt);
    this.readAt = data.readAt ? new Date(data.readAt) : null;
    this.deletedAt = data.deletedAt ? new Date(data.deletedAt) : null;
  }
}

export class DeleteCaseReminderResponse {
  public static readonly DELETED: number = 1;
  public static readonly NO_REMINDER: number = 2;

  constructor(status: number) {
    this._status = status;
  }

  private _status: number;

  public get status(): number {
    return this._status;
  }

  public set status(value: number) {
    this._status = value;
  }
}
